import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from '@/shared/ui';
import { LicenseNoticeContext } from './license-notice-context';

/**
 * Okno informujace, ze kliknięty modul nie jest objety licencja biezacego pakietu.
 *
 * Trzymamy je w jednym miejscu na poziomie aplikacji, bo komunikat wywoluja
 * zarowno kafelki strony startowej, jak i pozycje nawigacji — kazdy widok
 * z wlasnym oknem oznaczalby kilkanascie kopii tego samego stanu.
 */
export function LicenseNoticeProvider({ children }: { children: ReactNode }) {
  const { t } = useTranslation('common');
  const [moduleLabel, setModuleLabel] = useState<string | null>(null);

  const showLicenseNotice = useCallback((label: string) => {
    setModuleLabel(label);
  }, []);

  const value = useMemo(() => ({ showLicenseNotice }), [showLicenseNotice]);

  return (
    <LicenseNoticeContext.Provider value={value}>
      {children}

      <Modal
        open={moduleLabel !== null}
        onClose={() => setModuleLabel(null)}
        title={t('license.title')}
        description={moduleLabel ?? undefined}
        size="sm"
        footer={<Button onClick={() => setModuleLabel(null)}>{t('license.confirm')}</Button>}
      >
        <p className="text-fg-muted leading-relaxed">{t('license.body')}</p>
      </Modal>
    </LicenseNoticeContext.Provider>
  );
}
